<section class="project-quote-dialog custom-scrollbar">
  <div class="project-quote-dialog__header">
    @if (dialogData?.title) {
      <h4 class="project-quote-dialog__title">
        {{ dialogData.title | translate }}
      </h4>
    }

    <button type="button" (click)="close()">
      <i class="iconsax project-quote-dialog__icon" icon-name="x"></i>
    </button>
  </div>

  <form
    class="project-quote-dialog__form"
    [formGroup]="quoteForm"
    (submit)="submitQuote()">
    <pwj-input
      class="project-quote-dialog__input"
      type="number"
      icon="clock"
      iconPosition="left"
      label="projects.quote.estimatedTime"
      placeholder="projects.quote.estimatedTimePlaceholder"
      formControlName="estimated_time"
      [messages]="{
        required: 'projects.quote.estimatedTimeRequired',
        min: 'projects.quote.estimatedTimeMin',
      }" />

    <div class="project-quote-dialog__toggle">
      <pwj-toggle-switch
        label="projects.quote.negotiable"
        [isChecked]="quoteForm.get('is_negotiable')?.value"
        (onToggle)="onNegotiableToggle($event)" />
    </div>

    @if (!isNegotiable) {
      <pwj-input
        class="project-quote-dialog__input project-quote-dialog__amount-input"
        type="number"
        icon="coins-3"
        iconPosition="left"
        placeholder="projects.quote.totalAmountPlaceholder"
        label="projects.quote.totalAmount"
        formControlName="total_amount"
        [messages]="{
          required: 'projects.quote.totalAmountRequired',
          min: 'projects.quote.totalAmountMin',
        }" />
    }

    <pwj-input
      class="project-quote-dialog__input"
      icon="stickynote"
      iconPosition="left"
      [isTextAreaMode]="true"
      placeholder="projects.quote.descriptionPlaceholder"
      label="projects.quote.description"
      rows="3"
      formControlName="description" />

    <div class="project-quote-dialog__footer">
      <div class="dialog-message">
        @if (!hasAccessToCreateQuote) {
          <span class="dialog-message__icon">
            <i class="info-name__icon iconsax" icon-name="info-circle"></i>
          </span>
          <span class="dialog-message__text">
            {{ 'global.accessDeniedDescription' | translate }}
          </span>
        }
      </div>

      <pwj-button
        [ngClass]="{ 'cursor-not-allowed': !hasAccessToCreateQuote }"
        class="submit-btn"
        variant="primary"
        size="medium"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        type="submit"
        [disabled]="
          !hasAccessToCreateQuote ||
          quoteForm.invalid ||
          isDisabledSubmitBtn ||
          formIsSubmitting
        ">
        {{ 'global.send' | translate }}
      </pwj-button>
    </div>
  </form>
</section>
